export default "__VITE_ASSET__ClUyDG$J__"